import { useLoggingActions } from "./useLogging";

/**
 * Hook do logowania operacji na zawodnikach
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko logowanie
 */
export const useParticipantLogging = () => {
  const { logParticipantCreate, logParticipantUpdate, logParticipantDelete } = useLoggingActions();

  /**
   * Loguje operację na zawodniku z obsługą błędów
   */
  const logOperation = async (
    logFunction: (...args: any[]) => Promise<any>,
    ...args: any[]
  ): Promise<void> => {
    try {
      await logFunction(...args);
    } catch (loggingError) {
      console.warn("Błąd logowania (ignorowany):", loggingError);
    }
  };

  /**
   * Loguje utworzenie zawodnika
   */
  const logCreate = async (
    participant: any,
    success: boolean,
    error?: string,
    metadata?: any
  ): Promise<void> => {
    await logOperation(logParticipantCreate, participant, success, error, metadata);
  };

  /**
   * Loguje aktualizację zawodnika
   */
  const logUpdate = async (
    oldParticipant: any,
    newParticipant: any,
    success: boolean,
    error?: string,
    metadata?: any
  ): Promise<void> => {
    await logOperation(
      logParticipantUpdate,
      oldParticipant,
      newParticipant,
      success,
      error,
      metadata
    );
  };

  /**
   * Loguje usunięcie zawodnika
   */
  const logDelete = async (
    participant: any,
    success: boolean,
    error?: string,
    metadata?: any,
    deactivatedParticipant?: any
  ): Promise<void> => {
    await logOperation(
      logParticipantDelete,
      participant,
      success,
      error,
      metadata,
      deactivatedParticipant
    );
  };

  return {
    logCreate,
    logUpdate,
    logDelete,
  };
};
